<template>
  <div>
    <template v-if="'simple' === mode">
      <div class="v-szn-simple">
        <div class="v-szn-img">
          <img :src="thumb" />
        </div>
        <div class="v-szn-title">
          <div class="v-szn-main" :style="{ color: titleColor }">
            {{ title }}
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="v-szn-logo">
        <div class="v-szn-img">
          <img :src="thumb" />
        </div>
        <div class="v-szn-title">
          <div class="v-szn-main" :style="{ color: titleColor }">
            {{ title }}
          </div>
          <div class="v-szn-sub" :style="{ color: subTitleColor }">
            {{ subTitle }}
          </div>
        </div>
        <div class="v-szn-extra">
          <slot name="extra"></slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: {
    mode: {
      type: String,
      default: "basic",
    },
    thumb: {
      type: String,
      default: require("@/assets/logo.png"),
    },
    title: {
      type: String,
      default: "三只鸟云课堂",
    },
    subTitle: {
      type: String,
      default: "重庆施工现场培训平台",
    },
    titleColor: {
      type: String,
      default: "rgb(46,46,47)",
    },
    subTitleColor: {
      type: String,
      default: "rgb(160,160,160)",
    },
  },
};
</script>

<style lang="less" scoped>
.v-szn-logo {
  height: 64px;
  box-sizing: border-box;
  float: left;
  display: flex;
  overflow: hidden;

  .v-szn-img {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    img {
      max-height: 48px;
    }
  }
  .v-szn-title {
    padding: 4px 0;
    flex-shrink: 0;
    padding-left: 12px;
    .v-szn-main {
      font-size: 24px;

      height: 32px;
      line-height: 32px;
    }
    .v-szn-sub {
      margin-top: 6px;
      height: 26px;

      line-height: 26px;
      border-top: 1px solid #f1f1f1;
      text-align: justify;
      text-align-last: justify;
    }
  }
  .v-szn-extra {
    flex: 1;
  }
}
.v-szn-simple {
  display: flex;
  .v-szn-img {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    img {
      max-height: 32px;
    }
  }
  .v-szn-title {
    flex: 1;
    padding-left:8px;
    .v-szn-main {
      
      font-size: 24px;
    }
  }
}
</style>
